<ng-container>
    <div class="selected-installation-text">
        <!-- First line: Kundenr. / Second line: Adresse -->
        <div class="line-primary fg-petroleum" [ngClass]="{ 'small-font-size': smallSize }">
            <div class="primary-row">
                <span
                    class="body-header customer-number-label"
                    translate="userProfile.customerRelations.customerNumber"
                ></span>
                <span class="body-copy value">
                    {{ customerNumber }}
                    @if (installation?.address) {
                        - {{ formatAddress(installation.address) }}
                    }
                </span>
            </div>
        </div>

        <!-- Second line: Installation / Aftagenr. / Måler -->
        <div class="line-secondary fg-petroleum" [ngClass]="{ 'small-font-size': smallSize }">
            <span class="info-pair body-small">
                <span class="body-small font-bold" translate="userProfile.customerRelations.installationTitle"></span>
                <span class="body-small">{{ formatValueWithPeriod(installation?.installationNumber) }}</span>
            </span>
            <span class="info-pair body-small">
                <span class="body-small font-bold">Aftagenr.:</span>
                <span class="body-small">{{ formatValueWithPeriod(meteringPoint) }}</span>
            </span>
            <span class="info-pair body-small">
                <span class="body-small font-bold" translate="userProfile.customerRelations.meter"></span>
                <span class="body-small">
                    {{ installation?.meterNumber || '-' }}
                    @if (isProductionInstallation) {
                        <span translate="userProfile.customerRelations.biogasProduction"></span>
                    }
                    @if (elVarmeProductionLabel) {
                        <span [translate]="elVarmeProductionLabel"></span>
                    }
                </span>
            </span>
        </div>
    </div>

    <!-- Closed contract info -->
    @if (installation.contract?.isClosed) {
        <strong
            class="flex flex-col whitespace-pre-line text-green"
            [ngClass]="{ 'small-font-size': smallSize }"
            translate="customerRelations.closedContract"
        >
        </strong>
    }
</ng-container>
